import { apiGet } from 'api';
import { GetExtensionRequestStatusesResponse } from '../types';

export const getExtensionRequestStatuses = (): Promise<GetExtensionRequestStatusesResponse> =>
  apiGet<GetExtensionRequestStatusesResponse>('extensionrequeststatuses');
